import React from 'react';
import MediaQuery from 'react-responsive';
import { useAppendAuthorizationHeader } from '../utils/connector/api-connector';
// import { RouteComponentProps, withRouter } from 'react-router';
import { Card } from 'antd';
import Spinner from '../components/Spinner/Spinner';
import EventStatusIcon from '../components/icons/EventStatusIcon';
import ElementsInfo from '../components/Views/ElementsInfo';
import DNSSECAccreditationIcon from '../components/icons/DNSSECAccreditationIcon';
import AccreditationIcon from '../components/icons/AccreditationIcon';
// import { rootAPI } from '../constants/globals';
import Flex from '../components/StyledComponents/Flex';
import { setUrlToHTTPs } from '../utils';
import { useTranslation } from '@nic-react-i18n/core';
import { useQuery } from '@tanstack/react-query';
import { AppConf } from '../AppConf';
import { useKeycloak } from '@nic-react/auth';


interface RequestsInfoInterface {
    type: string;
}
type RequestsInfoProps =
    RequestsInfoInterface

export const RequestsInfo: React.FC<RequestsInfoProps> = (props) => {
    const {type} = props
    const {t} = useTranslation()
    const {keycloak} = useKeycloak()

    const component = (iconsSize: string, screenType: string,  pending: any, succeeded: any, failed: any) => {
        //console.log('FULFILLED: iconsize: ', iconsSize, pending, succeeded, failed);

        let pendingIcon = <EventStatusIcon status={'pending'}/>;
        let succeededIcon = <EventStatusIcon status={'succeeded'}/>;
        let failedIcon = <EventStatusIcon status={'failed'}/>;

        return (
            <Flex
                direction={'row'}
                justify={'space-between'}
                align={'center'}
                style={{
                    width: '100%'
                }}
            >
                <div>
                    <ElementsInfo
                        fontSize={iconsSize}
                        info={pending.page}
                        icon={pendingIcon}
                        label={'pending'}
                        url={`/requests?status=pending&type=${type}`}
                    />
                </div>

                <div>
                    <ElementsInfo
                        fontSize={iconsSize}

                        info={succeeded.page}
                        icon={succeededIcon}
                        label={'succeeded'}
                        url={`/requests?status=succeeded&type=${type}`}
                    />
                </div>

                <div>
                    <ElementsInfo
                        fontSize={iconsSize}
                        info={failed.page}
                        icon={failedIcon}
                        label={'failed'}
                        url={`/requests?status=failed&type=${type}`}
                    />
                </div>
            </Flex>
        )
    }



    const renderComponent =
        (component: (consSize: string, screenType: string, pending: any, succeeded: any, failed: any) => React.ReactElement<any> | undefined,
         fontSize: string, screenType: string, pending: any, succeeded: any, failed: any) => {


        let titleIcon = (
            type === 'dnssec' ?
                <DNSSECAccreditationIcon color={'red'} size={fontSize}/> :
                <AccreditationIcon color={'orange'} size={fontSize}/>
        );
        return (
            <Flex
                direction={'row'}
                justify={'space-between'}
                wrap={'wrap'}
                style={{
                    width: '100%',
                    paddingLeft: '5px',
                    paddingRight: '5px'

                }}
            >
                <Card
                    style={{
                        display: 'flex',
                        width: '100%',
                        flexWrap: 'wrap',
                    }}
                    styles={{
                        body: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        paddingTop: '15px',
                        paddingBottom: '15px',}
                }}
                >
                    <Flex
                        direction={'row'}
                        align={'center'}
                        justify={'center'}
                        style={{
                            fontSize: fontSize,
                            fontWeight: 300,
                            width: '100%',
                            paddingBottom: '10px',
                            marginBottom: '10px',
                            borderBottom: '1px solid #ededef',
                        }}
                    >
                        {t('request.accreditation')}
                        {titleIcon}
                        {type}
                    </Flex>

                    {component(fontSize, screenType, pending, succeeded, failed)}

                </Card>
            </Flex>
        );
    }

    const header = useAppendAuthorizationHeader()

    const pending = useQuery({
        queryKey: [`${props.type}`, 'pending'],
        queryFn: async () => {
            const {url:rootAPI} = AppConf.getRootUrl(keycloak.realm ? keycloak.realm : '');
            const data =
                await fetch(setUrlToHTTPs(`${rootAPI}/requests?status=pending&type=${props.type}&size=1`), {...header})
            return data.json()
        }}
    )

    const failed = useQuery({
        queryKey: [`${props.type}`,'failed'],
        queryFn: async () => {
            const {url:rootAPI} = AppConf.getRootUrl(keycloak.realm ? keycloak.realm : '');
            //https://accreditation-service.devel.nic.it/
            const data =
                await fetch(setUrlToHTTPs(`${rootAPI}/requests?status=failed&type=${props.type}&size=1`), {...header})
            return data.json()
        }}
    )
    const succeeded = useQuery({
        queryKey: [`${props.type}`,'succeeded'],
        queryFn: async () => {
            const {url:rootAPI} = AppConf.getRootUrl(keycloak.realm ? keycloak.realm : '');
            const data =
                await fetch(setUrlToHTTPs(`${rootAPI}/requests?status=succeeded&type=${props.type}&size=1`), {...header})
            return data.json()
        }}
    )

    if (pending.isFetching || failed.isFetching || succeeded.isFetching) {
        return <Spinner/>
    }

    if (pending.isFetched && failed.isFetched && succeeded.isFetched) {

        return (
            <div style={{width: '100%'}}>
                <MediaQuery minWidth={1224}>
                    {renderComponent(component, '1.5vw', 'large', pending.data, succeeded.data, failed.data)}
                </MediaQuery>

                <MediaQuery minWidth={850} maxWidth={1224}>
                    {renderComponent(component, '3vw', 'medium', pending.data, succeeded.data, failed.data)}
                </MediaQuery>

                <MediaQuery minWidth={300} maxWidth={849}>
                    {renderComponent(component, '4vw', 'small', pending.data, succeeded.data, failed.data)}
                </MediaQuery>
            </div>
        )

    }

    if (pending.isError || failed.isError || succeeded.isError) {
        return (
            <span>Error</span>
        )
    }
    return (<Spinner/>)
    }
